import { Box, Popover, SearchField } from "@drone-js/core";
import { VStack } from "apps/commons/components/Stack";
import { useState } from "react";
import { useStaticDataAtomValue } from "../../staticDataAtom";
import { useSetExpandManualLocationAtom } from "../expandManualLocationAtom";
import type { GooglePlaceResult } from "../types";
import { SearchItem } from "./SearchItem";
import { useMapSearchHandler } from "./useMapSearchHandler";

export const MapSearchController = () => {
    const [display, setDisplay] = useState("");
    const { input, setInput, items, handleSelectPlace } = useMapSearchHandler();
    const [popoverVisible, setPopoverVisible] = useState(false);
    const {
        cmsData: {
            location: { searchForYourPropertyLocation },
        },
    } = useStaticDataAtomValue();
    const setExpandManualLocationAtom = useSetExpandManualLocationAtom();

    const handleSearchItemClick = (place: GooglePlaceResult) => {
        setDisplay(place.name + " " + place.formatted_address);
        handleSelectPlace(place);
        setExpandManualLocationAtom(true);
        setPopoverVisible(false);
    };

    const popoverContent = (
        <VStack gap="0">
            {items.map((place) => (
                <SearchItem
                    key={`map-search-item-${place.place_id}`}
                    userInput={input}
                    place={place}
                    onClick={handleSearchItemClick}
                />
            ))}
        </VStack>
    );

    return (
        <Box display="flex" width="100%">
            <Popover
                pointerPosition="above"
                content={popoverContent}
                visible={popoverVisible && items.length > 0}
                onVisibilityChange={setPopoverVisible}
                flexWrapper={{
                    flex: 1,
                }}
            >
                <SearchField
                    variant="input"
                    placeholderText={searchForYourPropertyLocation}
                    leadingAsset={{
                        id: "fill.symbol.search",
                    }}
                    label="Search"
                    clearLabel="Clear"
                    inputText={display}
                    onChange={(e) => {
                        setDisplay(e.currentTarget.value);
                        setInput(e.currentTarget.value);
                    }}
                    data-element-name="location-search-field"
                />
            </Popover>
        </Box>
    );
};
